module.exports = __webpack_public_path__ + "static/omvic-logo-3e3cc48044d651f89c7510e30062740a.jpg";